import { useSelector } from "react-redux";
import { useEffect } from "react";
import { ThemeTypes } from "@/utils/constants";

export const useTheme = () => {
  const profile = useSelector((state) => state.profile);

  useEffect(() => {
    if (profile.data?.webTheme) {
      document.documentElement.classList.remove("light-theme", "dark-theme");
      document.documentElement.classList.add(profile.data.webTheme ? `${profile.data.webTheme.id.toLowerCase()}-theme` : "dark-theme");
    }
  }, [profile.data?.webTheme]);

  return {
    isDarkTheme: profile.data?.webTheme ? profile.data.webTheme.id === ThemeTypes.dark.id : true,
    isLightTheme: profile.data?.webTheme ? profile.data?.webTheme?.id === ThemeTypes.light.id : false,
  };
};
